import React, { useState, useEffect, useRef } from "react";
import { msalInstance } from "../index";
import moment from "moment";
import Table from "react-bootstrap/Table";
import { getEvents } from "../components/services/graphService";
import config from "../config.json";
import { toast } from "react-toastify";

function Calendar(props) {
  let [events, setEvents] = useState([]);
  const isMountedRef = useRef(true);
  const [whoAmI, setWhoAmI] = useState("");

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  useEffect((props) => {
    async function getList() {
      try {
        var accessToken = await msalInstance.acquireTokenSilent({
          scopes: config.scopes,
        });
        var events = await getEvents(accessToken);
        return events;
      } catch (err) {
        props.showError("ERROR", JSON.stringify(err));
      }
    }
    console.log("Calendar");
    getList().then((response) => {
      if (response && isMountedRef.current) {
        setEvents(response.value);
      }
    });

    toast.success("Called Graph Calendar API");
  }, []);

  useEffect(() => {
    let divisions = [];

    JSON.parse(
      localStorage.getItem("safyInfo")
    ).user.safyInfo.Divisions.forEach((element) => {
      divisions.push(element.DivisionName);
    });
    setWhoAmI(divisions);
  }, []);

  const formatDateTime = (datetime) => {
    if (datetime !== undefined) {
      return moment.utc(datetime).local().format("M/D/YY h:mm A");
    }
  };

  return (
    <div>
      {whoAmI !== {} && <div>{JSON.stringify(whoAmI)}</div>}
      <h1>Calendar</h1>
      <Table>
        <thead>
          <tr>
            <th scope="col">Organizer</th>
            <th scope="col">Subject</th>
            <th scope="col">Start</th>
            <th scope="col">End</th>
          </tr>
        </thead>
        <tbody>
          {events.map(function (event) {
            return (
              <tr key={event.id}>
                <td>{event.organizer.emailAddress.name}</td>
                <td>{event.subject}</td>
                <td>{formatDateTime(event.start.dateTime)}</td>
                <td>{formatDateTime(event.end.dateTime)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default Calendar;
